<template>
  <div id="ManualSet">
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @search="search"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
  </div>
</template>

<script>
import { getPlaceList } from '@/http/modules/baseSet/examSite';

export default {
  data() {
    return {
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点',
          type: 'select',
          requestKey: 'placeId'
        },
        {
          title: '考试场次',
          type: 'select',
          requestKey: 'session'
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'school'
        }
      ],

      tableData: [],

      tableHeader: [
        {
          title: '序号',
          prop: 'planName'
        },
        {
          title: '考点',
          prop: 'stationName'
        },
        {
          title: "考试场次",
          prop: "realName",
        },
        {
          title: "教室名称",
          prop: "cardNo",
        },
        {
          title: "考位",
          prop: "phone",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "已安排人数",
          prop: "score",
        },
        {
          title: "操作",
          prop: "auditState",
        },
      ],

      pagination: {
        total: 0
      },

      requestForm: {
        planId: '',
        size: 10,
        page: 1,
      }
    }
  },
  watch: {
    'requestForm.planId': 'selectPlaceList'
  },
  mounted(){
    this.initData()
  },
  methods: {
    // 初始化数据
    initData(){
      this.mixin_getSelectPlan().then((data) => {
        if (data) {
          this.$set(this.selectList[0], "data", data)
          this.requestForm.planId = data[0].id
        }
      })

    },

    // 查询考点
    selectPlaceList(){

      






      console.log(111);
      let params = {
        planId: this.requestForm.planId,
      }
      getPlaceList(params).then(res=>{
        console.log(res);
      })
    },

    search(){

    },


    
    changeSize(num) {
        this.requestForm.size=num
        // this.getClassList()
    },
    changePage(p) {
        this.requestForm.page=p
        // this.getClassList()
    },    
  }
}



</script>

<style lang='less' scoped>

</style>
